import React, { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { AdminCard } from "./AdminLayout";
import { ImageUpload } from "./ImageUpload";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

function useReload() {
  const { reload } = useStore();
  return reload;
}

export function AdminCategories() {
  const { categories, reload } = useStore();
  const [f, setF] = useState({ name: "", slug: "", image: "" });
  const add = async () => { try { await api.post("/admin/categories", { ...f, slug: f.slug || f.name.toLowerCase().replace(/\s/g, "-") }); toast("Added"); setF({ name: "", slug: "", image: "" }); reload(); } catch (e) { toast.error(apiErr(e)); } };
  const del = async (c) => {
    const n = c.slug === "sale" || c.slug === "best-sellers" || c.slug === "new-arrivals" ? "This removes the tag from all products." : "All products in this category will be deleted too.";
    if (!window.confirm(`Delete "${c.name}"? ${n}`)) return;
    try { const r = await api.delete(`/admin/categories/${c.id}`); toast(`Deleted · ${r.data.products_affected} products affected`); reload(); } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Categories</h1>
      <AdminCard className="mb-4 flex flex-wrap gap-2 items-end">
        <input placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="border border-sharoa-line px-3 py-2 text-sm" />
        <ImageUpload value={f.image} onChange={(v) => setF({ ...f, image: v })} testId="category-image-upload" />
        <button onClick={add} className="bg-sharoa-rose text-white text-xs uppercase tracking-widest px-4 py-2 flex items-center gap-1"><Plus size={14} /> Add</button>
      </AdminCard>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {categories.map((c) => (
          <AdminCard key={c.id} className="p-3">
            <img src={c.image} alt="" className="w-full h-28 object-cover mb-2" />
            <div className="flex justify-between items-center"><span className="text-sm">{c.name}</span><button data-testid={`delete-category-${c.slug}`} onClick={() => del(c)}><Trash2 size={14} className="text-red-500" /></button></div>
          </AdminCard>
        ))}
      </div>
    </div>
  );
}

export function AdminCollections() {
  const { collections, reload } = useStore();
  const [f, setF] = useState({ name: "", slug: "", image: "", description: "" });
  const add = async () => { try { await api.post("/admin/collections", { ...f, slug: f.slug || f.name.toLowerCase().replace(/\s/g, "-") }); toast("Added"); setF({ name: "", slug: "", image: "", description: "" }); reload(); } catch (e) { toast.error(apiErr(e)); } };
  const del = async (c) => {
    if (!window.confirm(`Delete collection "${c.name}"? Products will be unlinked from it.`)) return;
    try { const r = await api.delete(`/admin/collections/${c.id}`); toast(`Deleted · ${r.data.products_affected} products unlinked`); reload(); } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Collections</h1>
      <AdminCard className="mb-4 flex flex-wrap gap-2 items-end">
        <input placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="border border-sharoa-line px-3 py-2 text-sm" />
        <input placeholder="Description" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} className="border border-sharoa-line px-3 py-2 text-sm flex-1" />
        <ImageUpload value={f.image} onChange={(v) => setF({ ...f, image: v })} testId="collection-image-upload" />
        <button onClick={add} className="bg-sharoa-rose text-white text-xs uppercase tracking-widest px-4 py-2 flex items-center gap-1"><Plus size={14} /> Add</button>
      </AdminCard>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {collections.map((c) => (
          <AdminCard key={c.id} className="p-3">
            <img src={c.image} alt="" className="w-full h-32 object-cover mb-2" />
            <div className="flex justify-between items-center"><span className="text-sm">{c.name}</span><button data-testid={`delete-collection-${c.slug}`} onClick={() => del(c)}><Trash2 size={14} className="text-red-500" /></button></div>
          </AdminCard>
        ))}
      </div>
    </div>
  );
}
